import { useTypedSelector } from 'lib/centralStore';
import { selectSistemiByType, selectTipo } from '../carrelloSelectors';

import { Root as Accordion } from '@radix-ui/react-accordion';
import { useState } from 'react';
import styles from './CarrelloCombinazioni.module.scss';
import { CarrelloSistemiItem } from './components/carrelloCombinazioniItem';

export const CarrelloCombinazioni = () => {
  const carrelloType = useTypedSelector(selectTipo);
  const sistemi = useTypedSelector((state) => selectSistemiByType(state, carrelloType));
  const [activeAccordions, setActiveAccordions] = useState<string[]>([]);

  const handleAccordionToggle = (id: string, isEnabled: boolean) => {
    setActiveAccordions((prev) => (isEnabled ? prev : prev.filter((item) => item !== id)));
  };

  return (
    <Accordion type="multiple" className={styles.root} value={activeAccordions} onValueChange={setActiveAccordions}>
      {sistemi?.map((sistema) => (
        <CarrelloSistemiItem id={sistema.id} key={sistema.id} handleAccordionToggle={handleAccordionToggle} />
      ))}
    </Accordion>
  );
};
